/**
 * Non-base locales, which paraglide serves under a path prefix
 * (`/es/academic`). The single source of truth for locale-prefixed path
 * handling — but note two consumers CANNOT import it:
 * `./marketing-path.ts` and `./geo-redirect.ts` ride in the byte-budgeted
 * CloudFront Functions bundle where even the derived-regex plumbing blew the
 * injection budget (3,692 > 3,674 bytes), so they keep hand-inlined `/es`
 * literals. `test/unit/analytics/locale-prefixes.test.ts` pins this list AND
 * both literals against paraglide's own `locales`, so adding a locale fails
 * loudly in all three places rather than silently leaving that locale's
 * traffic unbucketed, uncacheable, or un-country-keyed.
 *
 * `./experimental-routes.ts` imports it directly (also edge-bundled, but the
 * array literal was already in that bundle, so the import is byte-neutral).
 * Hand-authored rather than imported from `@/paraglide/runtime`: the
 * paraglide runtime is far too big to ride along in the edge bundle.
 */
export const NON_BASE_LOCALE_PREFIXES = ['es'] as const;
